/** The currency of each country (by its ISO 3166 code) the Keepo's people are most from; the rest fall back. */
const BY_COUNTRY: Record<string, string> = {
  BR: "BRL",
  US: "USD",
  PT: "EUR",
  ES: "EUR",
  FR: "EUR",
  DE: "EUR",
  IT: "EUR",
  IE: "EUR",
  NL: "EUR",
  BE: "EUR",
  AT: "EUR",
  GB: "GBP",
  CH: "CHF",
  CA: "CAD",
  AU: "AUD",
  AR: "ARS",
  MX: "MXN",
  CL: "CLP",
  CO: "COP",
  PE: "PEN",
  UY: "UYU",
  PY: "PYG",
  BO: "BOB",
  AO: "AOA",
  MZ: "MZN",
  JP: "JPY",
  IN: "INR",
};

/**
 * The currency guessed before the person chooses one in the Account: Real for an account in Portuguese (as the API's
 * User::currencyOf); else the country of the browser's languages ("en-GB" → Pound), the first one known; else Real
 * for a Portuguese browser and Dollar for the rest.
 */
export const guessCurrency = (languages: readonly string[], accountLang?: string): string => {
  if (accountLang?.toLowerCase().startsWith("pt")) return "BRL";
  for (const language of languages) {
    const country = language.split(/[-_]/)[1]?.toUpperCase();
    if (country && BY_COUNTRY[country]) return BY_COUNTRY[country];
  }
  return languages[0]?.toLowerCase().startsWith("pt") ? "BRL" : "USD";
};
